// extracted by mini-css-extract-plugin
module.exports = {"container":"channel-form-container__1aG4A"};